import { cDateField } from "../../components/date-field/date-field";
import { cUtil }      from "../../functions/util";

export class cOrderListOverviewItem {

  div_outer      = document.createElement('div');
  div_name       = document.createElement('div');
  div_message    = document.createElement('div');
  div_countLabel = document.createElement('div');
  div_count      = document.createElement('div');
  div_price      = document.createElement('div');
  button_send    = document.createElement('button');

  validDates    : string[]; 
  list          : OrderList;
  nonce         : string;
  deliveryDate  : cDateField;

  constructor(
    list: ListData,
    form  : HTMLFormElement,
    nonce : string 
  ) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    this.validDates = list.validDates;
    this.list       = list.list;
    this.nonce      = nonce;

    form.append(this.div_outer);
      this.div_outer.append(this.div_name);
      this.div_outer.append(this.div_countLabel);
      this.div_outer.append(this.div_count);

      const deliveryDateLabel = 
        cUtil.customerPickUp()
        ? __('Abholung', 'custom')
        : __('Lieferung', 'custom');

      this.deliveryDate = new cDateField({
        validDates   : list.validDates, 
        initDate     : this.list.delivery_date,
        label        :  deliveryDateLabel,
        placeholder  : __('Nicht festgelegt', 'custom'),
        parentElm    : this.div_outer, 
        parentObj    : this,
        eventDefault : 'cOrderListOverviewItem_constructor_deliveryDate',
        cssClass     : 'c-delivery-date',
        emptyAllowed : true,
      });

      this.div_outer.append(this.div_price);
      this.div_outer.append(this.button_send);
      this.div_outer.append(this.div_message);

    // ---- Texts ----
    const produkte = list.numberOfItems === 1 ? __('Produkt', 'custom') : __('Produkte', 'custom');
    this.button_send.setAttribute('aria-label', __('Bestellen', 'custom'))
    this.div_price.innerText      = `CHF ${list.value}`;
    this.div_countLabel.innerText = __('Produkte', 'custom') + ':';
    this.div_count.innerText      = String(list.numberOfItems);
    this.div_message.innerText    = list.message;
    this.div_name.innerText       = __(list.list.name, 'custom');
    const forGetText              = __('Offerten', 'custom');

    // ---- Classes ----
    this.div_outer      .classList.add('c-item');
    this.div_name       .classList.add('div_name');
    this.div_countLabel .classList.add('div_countLabel');
    this.div_count      .classList.add('div_count');
    this.div_price      .classList.add('div_price');
    this.button_send    .classList.add('button_send');
    this.div_message    .classList.add('div_message');
    if (list.numberOfItems === 0) {
      this.div_outer      .classList.add('c-item', 'c-empty-item');
    }
    
    
    if (list.message === '') {
      this.div_message.classList.add('c-hidden');
    }

    // ---- Other ----
    this.button_send.type = 'button';

    // ---- Events ----
    this.button_send.addEventListener('click', (e) => {
      e.stopPropagation();
      this.addToCart();
    });
    this.div_outer.addEventListener('click', () => {
      window.location.href = cUtil.url(`/bestelllisten/${list.list.list_id}`);
    });
    this.deliveryDate.input.addEventListener('click', (e)=> {
      e.stopPropagation();
    })

    // ---- Init ----
    this.validateItems();
  }

  changeEvent(eventSource: string): void {
    const isValid = this.validateItems();
    if (isValid) {
      this.list.delivery_date = this.deliveryDate.getDate();
    }
  }
  validateItem(silent: 'silent'|'', message: 'list'|''): boolean {
    return true;
  };
  validateItems() {
    const isValidCommonDate = this.deliveryDate?.validateItem('', 'list'); 
    

    return isValidCommonDate;
  }

  async addToCart() {
    const data  = JSON.stringify(this.list);
    const error = await this.fetch(data, 'c_order_list_overview_add_to_cart');

    if (error === 'ok') {
      window.location.href = cUtil.url('/warenkorb/');
      return;
    }
    this.div_message.innerText = error;
    this.div_message.classList.remove('c-hidden');
  }

  async fetch(data: string, action: string): Promise<string> {
    const  formData = new FormData();
    formData.append('_ajax_nonce', this.nonce);
    formData.append('action'     , action);
    formData.append('data'       , data);
  
    const response = await fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      body: formData
    });
    const responseData = await response.json() as string;
    return responseData;
  }
}
